import React from 'react';
import FormsySimpleInput from '../form/FormsySimpleInput';
import SimpleInput from '../form/SimpleInput';
import FormSelect from '../form/Select';
import SVGTrash from '../../svg/Trash';

class DishIngredient extends React.Component {
  availableMeasures = [
    { value: 'g', label: 'g' },
    { value: 'ea', label: 'ea' }
  ];

  render() {
    const {
      ingredient,
      componentIndex,
      subcomponentIndex,
      ingredientIndex,
      deleteIngredient
    } = this.props;
    return (
      <div className="dish-ingredient dish-ingredient__row">
        <div className="dish-ingredient__col dish-ingredient__col--name">
          <FormsySimpleInput
            type="text"
            name="friendly_name"
            value={ingredient.friendly_name || ''}
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="dish-ingredient__col dish-ingredient__col--prep">
          <SimpleInput
            type="text"
            name="prep"
            value={ingredient.prep || ''}
            onChange={this.handleChange}
          />
        </div>
        <div className="dish-ingredient__col dish-ingredient__col--quantity">
          <SimpleInput
            type="number"
            name="quantity"
            step="0.01"
            className="simple-input simple-input--center"
            value={ingredient.quantity || ''}
            onChange={this.handleChange}
          />
        </div>

        <div className="dish-ingredient__col dish-ingredient__col--measure">
          <FormSelect
            name="measurement"
            value={ingredient.measurement}
            onChange={this.handleSelectChange}
            options={this.availableMeasures}
          />
        </div>

        <div className="dish-ingredient__col dish-ingredient__col--multiplier">
          <SimpleInput
            type="number"
            name="small"
            step="0.01"
            className="simple-input simple-input--center"
            value={ingredient.multiplier.small || ''}
            onChange={this.handleMultiplierChange}
          />
        </div>
        <div className="dish-ingredient__col dish-ingredient__col--multiplier">
          <SimpleInput
            type="number"
            name="medium"
            step="0.01"
            className="simple-input simple-input--center"
            value={ingredient.multiplier.medium || ''}
            onChange={this.handleMultiplierChange}
          />
        </div>
        <div className="dish-ingredient__col dish-ingredient__col--multiplier">
          <SimpleInput
            type="number"
            name="large"
            step="0.01"
            className="simple-input simple-input--center"
            value={ingredient.multiplier.large || ''}
            onChange={this.handleMultiplierChange}
          />
        </div>
        <div className="dish-ingredient__col dish-ingredient__col--delete">
          <div
            className="dish-ingredient__delete"
            onClick={() =>
              deleteIngredient(
                componentIndex,
                subcomponentIndex,
                ingredientIndex
              )
            }
          >
            <SVGTrash />
          </div>
        </div>
      </div>
    );
  }

  handleSelectChange = val => {
    const { componentIndex, subcomponentIndex, ingredientIndex } = this.props;
    const ingredient = {
      ...this.props.ingredient,
      measurement: val ? val.value : ''
    };
    this.props.updateIngredient(
      componentIndex,
      subcomponentIndex,
      ingredientIndex,
      ingredient
    );
  };

  handleMultiplierChange = e => {
    const { componentIndex, subcomponentIndex, ingredientIndex } = this.props;
    const { name, value } = e.target;
    const ingredient = { ...this.props.ingredient };
    ingredient.multiplier = {
      ...ingredient.multiplier,
      id: null,
      [name]: value
    };
    this.props.updateIngredient(
      componentIndex,
      subcomponentIndex,
      ingredientIndex,
      ingredient
    );
  };

  handleChange = e => {
    const { componentIndex, subcomponentIndex, ingredientIndex } = this.props;
    const { name, value } = e.target;
    const ingredient = {
      ...this.props.ingredient,
      [name]: value
    };
    this.props.updateIngredient(
      componentIndex,
      subcomponentIndex,
      ingredientIndex,
      ingredient
    );
  };

  // shouldComponentUpdate(nextProps, nextState){
  //   return this.props.ingredient !== nextProps.ingredient;
  // }
}

export default DishIngredient;



// WEBPACK FOOTER //
// ./src/components/dish/DishIngredient.js